module.exports = __webpack_public_path__ + "img/28800.03b35f17.jpg";